export default __webpack_public_path__ + "static/media/Warlord's Axe.57915577.jpg";